﻿import { BaseEditor } from './base-editor';
import { IForm } from '../interface/form';
import { AsyncValidatorFn, ValidatorFn } from '../types/validator-fn';
import { IEditor } from '../interface/editor';

export const TextEditorTagName = 't-text';

export function createTextEditor(form: IForm,
    name: string,
    element: HTMLElement,
    validators: ValidatorFn[],
    asyncValidators: AsyncValidatorFn[]): IEditor {
    return new TTextEditor(form, name, element, validators, asyncValidators);
}

export class TTextEditor extends BaseEditor<string> {
    inputElement: HTMLInputElement = null!;

    constructor(
        form: IForm,
        name: string,
        element: HTMLElement,
        validators: ValidatorFn[],
        asyncValidators: AsyncValidatorFn[]) {
        super(form, name, element, validators, asyncValidators);

        const ele = element.querySelector<HTMLInputElement>('input.form-control');
        if (!ele) {
            throw new Error(`Invalid DOM of field ${name}`);
        }

        this.inputElement = ele;
        this.inputElement.addEventListener('change', (ev: Event) => {
            this.reValidate();
            this.notifyChanges(this.value);
        });
        this.inputElement.addEventListener('keyup', (ev: Event) => {
            this.reValidate();
            this.notifyChanges(this.value);
        });

    }

    get value(): string {
        return this.inputElement.value;
    }
    set value(value: string) {
        this.inputElement.value = value;
    }

    setDisabled(disabled: boolean): void {
        this.inputElement.disabled = disabled;
        this.setDisabledInternal(disabled);
    }

    setFocus():void {
        this.inputElement.focus();
    }
}